/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import { BTC, XRP, ETH, USDT, USDC, LINK, MATIC, DETO, Default } from '../customicons';

export const CoinComponents = {
  BTC,
  ETH,
  XRP,
  USDT,
  USDC,
  LINK,
  MATIC,
  DETO,
  TFC_USDT: USDT,
};

const CoinIcon = props => {
  const NewComponent = CoinComponents[props.coin];
  if (NewComponent) {
    return <NewComponent {...props} />;
  }
  return <Default />;
};

export default CoinIcon;
